import { SimpleGrid, Stack } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureCard, Heading } from '@feathr/components';

import { useMetaFeatureCards } from './MetaFeatureCards.hooks';

function MetaFeatureCards(): JSX.Element {
  const { t } = useTranslation();
  const featureCards = useMetaFeatureCards();

  return (
    <Stack gap={'xs'}>
      <Heading order={4} variant={'h4'}>
        {t('With our Meta integration you can:')}
      </Heading>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={'md'}>
        {featureCards.map(({ description, icon, label, name }) => (
          <FeatureCard icon={icon} key={name} label={label} name={name}>
            {description}
          </FeatureCard>
        ))}
      </SimpleGrid>
    </Stack>
  );
}

export default MetaFeatureCards;
